import type {
    ComponentStageData,
    MobileAlgoPlugin,
    MobileAlgoPluginInitializationArgs,
    PluginHeuristicsRegistry
} from '../../types'
import {alignmentHeuristics} from './heuristicsDefinitions'
import {createAdaptiveHeuristic} from '../common'

export const createPlugin = ({stages}: MobileAlgoPluginInitializationArgs): MobileAlgoPlugin => {
    const alignComponent = (componentStageData: ComponentStageData) => {
        const heuristicToApply = alignmentHeuristics.find(({predicate}) => predicate(componentStageData))

        if (!heuristicToApply) {
            return
        }

        heuristicToApply.apply(componentStageData)

        return {
            appliedHeuristics: [heuristicToApply.heuristicCode]
        }
    }

    const register = (registry: PluginHeuristicsRegistry) => {
        registry.register(stages.TRANSFORM_STYLE, createAdaptiveHeuristic(alignComponent))
    }

    const name = 'alignComponent'
    return {register, name}
}
